import { useNavigate } from 'react-router-dom'

import { AddEmployeeModalPageDocument } from 'generated/resources/graphql'

import AuthorizeUser from 'modules/core/components/AuthorizeUser'
import Loading from 'modules/core/components/Loading'
import { useNavigation } from 'modules/core/hooks/useNavigation'
import { useQuery } from 'modules/core/hooks/useQuery'
import { useStrictParams } from 'modules/core/hooks/useStrictParams'

import AddEmployeeModal from 'modules/work_schedules/components/AddEmployeesModal'
import schedules from 'modules/work_schedules/store/collections/schedules'

const AddEmployeeModalPage = () => {
  const { navigation } = useNavigation()

  const { id } = useStrictParams<'id'>()
  const navigate = useNavigate()
  const workScheduleId = String(id)

  const { data, loading } = useQuery(AddEmployeeModalPageDocument, {
    variables: {
      scheduleId: workScheduleId,
    },
  })

  const canAssignEmployees = data?.workSchedule.schedule?.canAssignEmployeesPolicy.can ?? false

  const onClose = () => {
    navigate(navigation.settings.workSchedule.id.employees.fullPath({ id: workScheduleId }))
  }

  const onSuccess = () => {
    navigate(navigation.settings.workSchedule.id.employees.fullPath({ id: workScheduleId }))
  }

  const workSchedule = schedules.get(workScheduleId)

  if (loading) {
    return <Loading />
  }

  return workSchedule ? (
    <AuthorizeUser authorizeFn={() => canAssignEmployees}>
      <AddEmployeeModal workSchedule={workSchedule} onClose={onClose} onSuccess={onSuccess} />
    </AuthorizeUser>
  ) : null
}

export default AddEmployeeModalPage
